import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { adminMe, auth } from '../lib/api';

const ProtectedRoute = ({ children }) => {
  const [status, setStatus] = useState('checking');

  useEffect(() => {
    if (!auth.getToken()) {
      setStatus('unauth');
      return;
    }
    adminMe()
      .then(() => setStatus('ok'))
      .catch(() => {
        auth.clear();
        setStatus('unauth');
      });
  }, []);

  if (status === 'checking') {
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-500">
        Verifica sessione...
      </div>
    );
  }
  if (status === 'unauth') return <Navigate to="/admin/login" replace />;
  return children;
};

export default ProtectedRoute;
